import LocationOnIcon from '@mui/icons-material/LocationOn'
import StarRateIcon from '@mui/icons-material/StarRate'
import ReadMoreText from 'components/common/read-more/text'
import ButtonGroups from './button-groups'

export default function BasicInfo() {
  const { profile } = useCtx('userId')
  const t = useI18n()
  const { stylist, tags } = profile

  const openReview = () => {
    const { isStudioAccount, studio } = stylist
    if (isStudioAccount) {
      h.reviewOpen({
        type: 'studio',
        id: studio.id
      })
      return
    }
    h.reviewOpen({
      type: 'stylist',
      id: profile.id
    })
  }

  const guaranteeTitle = stylist.isGuarantee ? { title: t('page:userId.guaranteeStylist', { name: profile.name }) } : null

  const renderBadge = () => {
    if (!guaranteeTitle) return
    return <div className='cursor-pointer' { ...guaranteeTitle } onClick={ nameClick }><C.Image src={ cdn('images/badge/guarantee256.png') } className='w-6 h-7' alt=''/></div>
  }

  const nameClick = () => {
    if (!guaranteeTitle) return
    h.openGuaranteeDetail()
  }

  return (
    <div className='container'>
      <div className='py-4 flex items-center space-x-5'>
        <div className='flex items-start'>
          <C.Image
            className='w-20 h-20 rounded-full shrink-0 md:w-28 md:h-28 md:mr-3'
            src={ profile.avatar }
          />
        </div>
        <div className='font-bold flex-1 md:pt-5'>
          <div className='text-lg flex items-center space-x-1'>
            <div className='line-clamp-1' { ...guaranteeTitle } onClick={ nameClick }>{ profile.name }</div>
            { renderBadge() }
          </div>
          <div className='text-gray-500 text-sm'>{ stylist.profession.name }</div>
          <div className='text-gray-500'>
            <div className='flex items-center'>
              <span className='text-yellow-400 -translate-y-0.5'>
                <StarRateIcon fontSize='inherit' />
              </span>
              <span className='text-xs cursor-pointer' onClick={ openReview }>
                { stylist.$rating } ({ t('page:userId.ratingCount', { count: stylist.$ratingCount }) })
              </span>
            </div>
          </div>
          <div className='w-full hidden md:block'>
            <ButtonGroups />
          </div>
        </div>
      </div>
      <div className='w-full md:hidden'>
        <ButtonGroups />
      </div>
      <div className='text-xs font-bold cursor-pointer pt-2 pb-3 flex items-center space-x-2'>
        <div className='flex items-center'>
          <span className='text-xl -translate-y-0.5 text-gray-500'>
            <LocationOnIcon fontSize='inherit'/>
          </span>
          <C.Link href={ h.path.studio({ id: stylist.studio.id }) } className='text-gray-500'>
            <span className='pl-1 text-sm line-clamp-1'>{stylist.studio.name} / {stylist.studio.address}</span>
          </C.Link>
        </div>
        <div className='shrink-0'>
          { h.mapUrl(t('common:openMap'), stylist.studio.address) }
        </div>
      </div>
      <div className='flex flex-wrap text-xs pb-3'>
        { tags.map(tag => (
          <C.Link key={ tag.id } noUnderline className='py-1 px-2 bg-gray-100 mr-[0.3rem] mb-[0.3rem] rounded-[4px] text-gray-500'
            href={ h.path.style({ id: tag.id }) }>
            # { tag.name }
          </C.Link>
        ))}
      </div>
      <ReadMoreText className='text-sm break-all' text={ profile.aboutMe } />
    </div>
  )
}
